<ng-container [formGroup]="form">
  <input
    [attr.data-qa-id]="question.label"
    [formControlName]="question.id"
    [id]="question.id"
    type="tel"
    mask="00/00/0000"
    [dropSpecialCharacters]="false"
    placeholder="MM/DD/YYYY"
    class="input"
  />
</ng-container>
